import React from "react";
import { motion } from "framer-motion";
import { FiCheck } from "react-icons/fi";

// swap if you want another image
import aboutImg from "../../../assets/reels_content/aboutpage/fox-thumbs-up.png";

const bullets = [
  "Prioritize player safety",
  "Player satisfaction and experience oriented",
  "Complete transparency and honesty",
];

const HeroSection = ({
  eyebrow = "Who we are",
  headingLead = "About",
  highlight = "Mr Reel",
  copy = `We're passionate about creating exceptional gaming experiences that bring joy, excitement, and entertainment to players around the world, while maintaining the highest standards of safety and responsibility.`,
  imageSrc = aboutImg,
}) => {
  return (
    <section className="bg-background dark:bg-darkbg text-black dark:text-textDark py-16 sm:py-24 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1400px] 2xl:max-w-[1600px] px-6 xl:px-10">
        {/* Left text / right image; vertically centered to match the mock */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          {/* LEFT: copy (explicit left-aligned text) */}
          <div className="max-w-[640px] text-left">
            <p className="text-text/70 dark:text-textDark/70 text-sm font-semibold mb-3">
              {eyebrow}
            </p>

            <h2 className="text-[34px] sm:text-5xl font-extrabold leading-tight mb-4">
              {headingLead} <span className="text-primary">{highlight}</span>
            </h2>

            <p className="text-text/80 dark:text-textDark/80 text-[15px] leading-relaxed mb-8">
              {copy}
            </p>

            <ul className="space-y-4">
              {bullets.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-[2px] inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary/10">
                    <FiCheck className="h-4 w-4 text-primary" />
                  </span>
                  <span className="text-[15px] font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT: image card with rounded corners */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.4 }}
            className="rounded-2xl overflow-hidden bg-surface dark:bg-surfaceDark border border-border dark:border-borderDark shadow-md"
          >
            <div className="aspect-[4/3] w-full">
              <img
                src={imageSrc}
                alt="About Mr Reel"
                className="w-full h-full object-cover"
                draggable={false}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
